// src/pages/Game/quick/QuickGame.jsx
import ClassicGame from "../classic/ClassicGame";
export default ClassicGame;
